import { useEffect, useState } from 'react'
import axios from 'axios'
//COMPONENTES PARTES

//INPORTAÇOES DE ICONES E IMAGENS
import IconChecked from '../../acets/img_icon/checked.svg'
import IconLixo from '../../acets/img_icon/lixo.svg'

import MenuPainelAdmin from '../partils/AdminMenuPainel'
import IconNoChecked from '../../acets/img_icon/nochecked.svg'
//import IconEdit from '../../acets/img_icon/edit.svg'

import AdminItensPedido from '../partils/AdminItensPedido'
import IcoStatus from '../partils/IcoStatus'

import IconSaberto from '../../acets/img_icon/ico_s_aberto.svg'
import IconScancel from '../../acets/img_icon/ico_s_cancel.svg'
import IconSfinalizado from '../../acets/img_icon/ico_s_finalizado.svg'
import IconSprod from '../../acets/img_icon/ico_s_prod.svg'
import IconSpromo from '../../acets/img_icon/ico_s_promo.svg'

//import TenancyColor from '../midllers/TenancyColor'
import { Link, useNavigate } from 'react-router-dom';
import AdminHeader from '../partils/AdminHeader'
import printJS from "print-js";

//import React, { useRef } from "react";
//import { useReactToPrint } from "react-to-print";
export default function AdminOrcamento(){
    const TenancyColorUser = localStorage.getItem('localcolorusers')
     const navigate = useNavigate();
    //CONGIGURAÇÕES=============================
    const config={
        pageName:'Orçamentos',
        mainstring:'nome',
        url:'/api/orcamento/',
        url2:'',
        search:'/api/orcamento/search/',
        urlOptions1:'/api/entregador',
        params:'',
        messegerError:'ATENÇÃO - Preencha os campos para salvar os dados ;D',
    }
     //INICIANDO CICLO DE ESTADOS
     useEffect(()=>{
        rec();
        // eslint-disable-next-line react-hooks/exhaustive-deps
        },[])
    //STATES======================================
    //id_pedido	status	forma_de_pagamento	troco	observacoes	cliente	createdAt	updatedAt
    const initialValues={ // DEFININDO UMA CONST PARA O STATE INICIAL 
        status: '',	forma_de_pagamento: '',	troco: '',bairro:'0',rua:'0',numero:'0',complemento:'0',observacoes:'null',	cliente: '', nome:''
    }
    const [openNew,setOpenNew]=useState(false)// ABRIR TELA DE CADASTRAR E EDITAR
    const [openDetaisStatusPedido,setOpenDetaisStatusPedido]=useState()// ABRIR TELA DE CADASTRAR E EDITAR
    const [values, setValues]=useState(initialValues) // INICIANDO UM STATE
    const [data, setData] = useState([])
    const [showfilters, setShowfilters]=useState(false)
    const [datafuncionario,setDatafuncionario]=useState([])
    
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0'); // Adiciona zero à esquerda, se necessário
    const day = String(today.getDate()).padStart(2, '0'); // Adiciona zero à esquerda, se necessário
    const formattedToday = `${year}-${month}-${Number(day) + 1}`;
    const modeviewcanvalocal = localStorage.getItem('keyCanvaMode')
    const [canvamode, setCanvamode] = useState(() => {
        const saved = localStorage.getItem('keyCanvaMode');
        return saved ? JSON.parse(saved) : modeviewcanvalocal;
      });
    const [intervalfinalDate, setIntervalfinalDate] = useState(formattedToday);

    const [intervalinitialDate,setIntervalinitialDate]=useState('2024-02-01')
    //const [idparamsPedido, setIdparamsPedido] = useState()
    const tlocal = localStorage.getItem('keyItemNameg')
    
    const headers = {
        'Content-Type': 'application/json',
        'token':tlocal,
    };
    //const [options1,setOptions1] = useState([])
    //FUNÇÕES=====================================
    function rec() {//CARREGAR ESTADOS E ATUALIZAR CICLO DE COMPONENTES
        axios.get(`/api/orcamento/${intervalinitialDate}/${intervalfinalDate}`, { headers }).then(resp => {
            const invalid = {ERRO: 'token invalido 3'};
                if (JSON.stringify(resp.data[0]) === JSON.stringify(invalid)) {
                  //navigate('/login');
                 // window.location.reload(true);
                }
                else{
                  setData(resp.data);
                }
                //console.log(data)
        })
        //console.log(data)
        axios.get('/api/clientefuncionario/').then(resp=>
            setDatafuncionario(resp.data)
        )
        
            
    }
    function onChange(ev) {//ALTERAR OS STATES DOS INPUTS
        const {name, value} = ev.target; //ESTRAIR O NAME E VALUE DO EV
        setValues({ ...values, [name]:value }); //SETANDO O VALUE EM NAME
    }


    function onChangeSelect(ev) {//ALTERAR OS STATES DOS INPUTS
        const {name, value} = ev.target; //ESTRAIR O NAME E VALUE DO EV
        setValues({ ...values, [name]:value }); //SETANDO O VALUE EM NAME
        //console.log(value)
        axios.get(value?'/api/orcamentostatus/'+value:config.url).then(resp=>{
            setData(resp.data)
           // console.log(resp.data)
        })
    }
    

    function alterar(idpedido,status) {
      axios.put('/api/orcamento/' + idpedido, { 'status': status }).then(resp => {
        rec();
      });
    }
    const exclui = function(id){//EXCLUI
        axios.delete(config.url + id).then(()=>{
            rec();
            setOpenNew(false)
            setValues(initialValues)
        })
    }
    function onSubmitSearch(ev){//PESQUISA
        console.log(values)
        ev.preventDefault();
        axios.post(config.search, values).then(respp=>{
            setData(respp.data)       
        })
       
    }
    {/*function redirectToWhatsapp(phoneNumber,idorcamento,idcliente) {
        const url = `https://wa.me/${phoneNumber}`;
        window.open(url, '_blank');
    }*/}
    function redirectToWhatsapp(phoneNumber, idorcamento, idcliente) {
        let message = '';
    
        if (idorcamento && idcliente) {
            const data = idcliente;
            const apenasNumeros = data.replace(/\D/g, ""); // Esta expressão regular substitui todos os caracteres não numéricos por uma string vazia
            //console.log(apenasNumeros); // Saída: "20240416201042000"

            message = `Segue o seu orçamento no link: https://autometricas.com.br/#/areadocliente/orcamentoAuth0/${idorcamento}/${apenasNumeros}`;
        } else {
            message = 'Olá! Como posso ajudá-lo?';
        }
    
        const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
        window.open(url, '_blank');
    }
    //console.log(datafuncionario)

    const finalfuncionario = datafuncionario.map(resp=>{
        return(<option value={resp.id_clientefuncionario}> {resp.cliente.nome}</option>)
    })
    
    const handlePrint = (id) => {
        printJS({
            printable: id, // ID do elemento a ser impresso
            type: "html",
            css: "/App.css", // Caminho correto do CSS
            style: `
                @page {
                    size: 80mm auto; /* Define largura fixa de 80mm */
                    margin: 0; /* Remove margens extras */
                }
                body {
                    font-family: Arial, sans-serif;
                    font-size: 12px;
                    width: 80mm; /* Garante que o conteúdo não ultrapasse 80mm */
                }
                .borda1 {
                    border: 1px solid black; /* Adiciona bordas se necessário */
                }
                .w100 {
                    width:100%;
                }
                .linha {
                    border-bottom: 1px solid black; /* Garante que linhas apareçam */
                    margin-bottom: 5px;
                }
                .column {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                }
            `, // Adiciona CSS para corrigir estilos e quebras de linha
            scanStyles: false, // Evita problemas ao carregar estilos da página
        });
    };
    
    //import estilo from'../../App.css'

function onChangeSelectFuncionario(ev) {
    const { name, value } = ev.target;
    setValues({ ...values, [name]: value });
    console.log(value)
    // Buscar os orçamentos do funcionário selecionado
    axios.get(value ? `/api/orcamentofuncionario/${value}` : "/api/orcamentofuncionario")
        .then(resp => setData(resp.data))
        .catch(err => console.error("Erro ao buscar orçamentos:", err));
}

    //console.log(data)

    const status1 = data.filter(item => item.status === 1); // Aguardando
    const status2 = data.filter(item => item.status === 2); // Pagamento pendente
    const status3 = data.filter(item => item.status === 3); // Finalizado pago
    const status4 = data.filter(item => item.status === 4); // Cancelado
    


    function final(dataprop){

        return(
        (!dataprop?data:dataprop).map(namesString => {
        const date = new Date(namesString.createdAt); //const formattedDate = `${date.getDate().toString().padStart(2, '0')}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getFullYear().toString()} às ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;
        const formattedDate = `${date.getDate().toString().padStart(2, '0')}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getFullYear().toString()}`;
        return (
            <div className='b2 h4 column center ma5 cont-circ7' 
              key={namesString.id_orcamento_venda }
              id={`printarea${namesString.id_orcamento_venda}`}
              style={{
                            borderLeft: `2px solid ${
                            namesString.status === 1
                                ? "#5280a6"
                                : namesString.status === 2
                                ? "#FFEC87"
                                : namesString.status === 3
                                ? "#47DA9A"
                                : namesString.status === 4
                                ? "#FFA487"
                                : "transparent"
                            }`,
                            width:`${
                                canvamode?'90%':'100%'
                            }`
                        }}
                    >
                <div className='w95 column center ma5'>
                    <div className='w100 row between '>
                        <div className='column cell-none'>
                            <label className='fs06em'>Nota N*</label>
                            <label className='fs06em'>{namesString.id_orcamento_venda}</label>
                        </div>
                       
                        <div className="w30 h4 row end cell-tamanho-metade">
                            <div className='w100 row end '>
                                <div className='fs06em c12 cell-tamanho fim w100'>{formattedDate}</div>
                                <div className='pp fs06em fb cell-none none' onClick={()=>handlePrint('printarea'+namesString.id_orcamento_venda)}>- PRINT</div>
                                <div className='row end w100'>
                                    <label onClick={()=>setOpenDetaisStatusPedido(namesString.id_orcamento_venda )||openDetaisStatusPedido===namesString.id_orcamento_venda &&setOpenDetaisStatusPedido(false) } className='fs06em fb  pp  cell-tamanho-metade50 cen cell-m0 c12 fim'>STATUS</label>
                                    <div className='pp fs06em fb w50 row end' onClick={() => navigate(`/adminvendarapidaEdtar/${namesString.id_orcamento_venda}`)}> EDITAR</div>
                                </div>
                                <div className='fs06em w100 fim'>{namesString.cliente_funcionario&&namesString.cliente_funcionario.cliente.nome}</div>
                            </div>
                            {openDetaisStatusPedido===namesString.id_orcamento_venda &&
                            <div className='w100 h100 posifixedinicio fundo-opaco left0 column center z17' onClick={()=>setOpenDetaisStatusPedido(false)}>
                                <div className='w40 h40 b2 cell-tamanho90 cont-circ8 column center'>
                                    <div className='w90'>
                                        <h5 className=''>Alterar Status</h5>
                                        <label className='w100'>Cliente:</label>
                                        <strong>{namesString.cliente.nome}</strong>
                                        <h6 className='w100'>Selecione o status:</h6>
                                        <div className='w100 linha ma10b0 pp pcb10 row pp' onClick={()=>alterar(namesString.id_orcamento_venda,1)}>
                                            <img src={IconSaberto} alt="fff" className='mac0l8'/>
                                            <label className='pp'>Aguardando Mercadoria/Serviço</label>
                                        </div>
                                        <div className='w100 linha ma10b0 pp pcb10 row pp' onClick={()=>alterar(namesString.id_orcamento_venda,2)}>
                                            <img src={IconSprod} alt="fff" className='mac0l8'/>
                                            <label className='pp'>Finalizado pagamento em aberto</label>
                                        </div>
                                        <div className='w100 linha ma10b0 pp pcb10 row pp' onClick={()=>alterar(namesString.id_orcamento_venda,3)}>
                                             <img src={IconSfinalizado} alt="fff" className='mac0l8'/>
                                            <label className='pp'>Finalizado Pago</label>
                                        </div>
                                        <div className='w100 linha ma10b0 pp pcb10 row pp' onClick={()=>alterar(namesString.id_orcamento_venda,4)}>
                                            <img src={IconScancel} alt="fff" className='mac0l8'/>
                                            <label className='pp'>Cancelado</label>
                                        </div>
                                        <div className='w100 linha ma10b0 pp pcb10 row pp' onClick={()=>exclui(namesString.id_orcamento_venda)}>
                                             <img src={IconScancel} alt="fff" className='mac0l8'/>
                                            <label className='pp'>Excluir</label>
                                            <label className='fs08em p10'>Para excluir o pedido exclua todos os itens do pedido. Esse é um recurso permanente e não poderá ser revertido.</label>
                                        </div>  
                                        <label className='fs08em'> Duvidas sobre o Carro?</label>
                                        <div className='w100 linha ma10b0 pp pcb10 row pp' onClick={() => redirectToWhatsapp(namesString.cliente.telefone)}>
                                            <label className='w100 c1 pp'>Contato via WhatsApp</label>
                                        </div>
                                        <button className='w100 ma10b0 row'
                                        style={{backgroundColor: TenancyColorUser}}
                                        onClick={() => redirectToWhatsapp(namesString.cliente.telefone,namesString.id_orcamento_venda,namesString.createdAt)}>
                                            <label className='w100 c3 pp'>Enviar Orçamento via WhatsApp </label>
                                        </button>
                                        <div className='row between ma25b0'>
                                            <label>Sem mais opções</label>
                                            <button className='btn05' onClick={()=>setOpenDetaisStatusPedido(false)}>Cancelar</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            }
                        </div>
                        <div className='w100 fw700  fs1p3em ma5 c11 column aligitensstart'> 
                            <label className='fb'>{namesString.cliente.nome}</label> 
                            <label className='c4 fs06em'> {namesString.cliente.carro}</label>
                        </div>
                    </div>
                    <div className='w100'>
                        <AdminItensPedido id={namesString.id_orcamento_venda}/>
                    </div>
                </div>
            </div>);
        })
        )
    }

   


    return(//id_pedido	status	forma_de_pagamento	troco	observacoes	cliente	createdAt	updatedAt
        <>
       <section className='h100 row between b31'>
           
            <MenuPainelAdmin/>
            <div className="h100 w80 cell-tamanho row center celular" >
                    <div className="w100 row between cell-tamanho celular">
                        <div className="h100 w100 cont-circ3  column cell-tamanho cell-paddingcb10" >
                        <h5 className='fs2em fb w90'>{config.pageName}</h5>
                        <form className=' w90 row center' onSubmit={onSubmitSearch} autoComplete='off'>
                            <div className='btn10 b37' onClick={() => navigate('/adminvendarapida')} style={{backgroundColor:TenancyColorUser}}>Add</div>
                            <div className='w60'>
                                <input type="text" name="nome" style={{background:'#FFF',border:'0'}} onChange={onChange} placeholder='Pesquisar orçamento'/>
                            </div>
                            <div className='w20 b37' style={{backgroundColor:TenancyColorUser}}>
                                <input type="submit" value="Pesquisar" className='cell-text-smile08' style={{backgroundColor:TenancyColorUser}}/>
                            </div>
                        </form>
                        <div className='w90 h20 column'>
                            
                            <div className='row center w100 h5'>
                                
                                {showfilters&&
                                    <div className="w100 b2 c3 flex row center ma10b0">
                                        <label className='w95 ma5'>Selecionar Status</label>
                                        <select name="status" onChange={onChangeSelect} className='w95'>
                                            <option value=''>Todos</option>
                                            <option value="1"> Aguardando peças/retifica</option>
                                            <option value="2"> Finalizado pagamento em aberto</option>
                                            <option value="3"> Finalizado Pago</option>
                                            <option value="4"> Cancelado</option>
                                        </select>
                                        <label className='w95 ma5'>Selecionar Funcionario</label>
                                        <select name="funcionario" onChange={onChangeSelectFuncionario} className='w95'>
                                           {finalfuncionario}
                                        </select>
                                        <label className="w95 ma5">Selecione o intervalo de datas para obter os dados</label> 
                                        <div className="w95 row between">
                                        <div className="w33">
                                            <label className="fs08em">Início</label>
                                            <input 
                                                type="date"
                                                onChange={(e) => setIntervalinitialDate(e.target.value)}
                                            />
                                        </div>
                                        <div className="w33" >
                                            <label className="fs08em">Fim</label>
                                            <input 
                                                type="date"
                                                onChange={(e) => setIntervalfinalDate(e.target.value)}
                                            />
                                        </div>
                                        <div className="w25">
                                            <label>Ação</label>
                                            <div className='b37' style={{backgroundColor:TenancyColorUser}}>
                                                <button className="w95 b37" onClick={()=>rec()} style={{backgroundColor:TenancyColorUser}}>ir</button>
                                            </div>
                                        </div>
                                        <label className="fs08em ma5">
                                            {"De: "+intervalinitialDate + " até " + intervalfinalDate} 
                                        </label>
                                        </div>
                                        
                                    </div>
                                    }
                                    <div className='row between w100'>
                                        <label className='w20 cell-none'>-</label>
                                        <label 
                                            className="w40 c1 cen fs08em pp p5 cell-tamanho"
                                            onClick={()=>setShowfilters(!showfilters)}>
                                            {showfilters?'Fechar Filtro':'Abrir Filtro'}
                                        </label>
                                        
                                        <label 
                                            className='w20 fim fs08em cell-none pp' 
                                            onClick={() => {
                                                const newMode = !canvamode;
                                                setCanvamode(newMode);
                                                localStorage.setItem('keyCanvaMode', JSON.stringify(newMode));
                                            }}
                                            >
                                            Modo Canva/Lista - <span className='fs08em fb pp'>Novo</span>
                                        </label>
                                    </div>
                            </div>
                               
                            {
                            !canvamode?
                            final():
                            <div className='w100 row between aligitensstart pcb20'>
                                <div className="b40  cont-circ15  w32 column center">
                                     <div className='row between w90'>
                                        <h6 className='pcb10 c8 fw600 pcb20'>🔄 Em andamento</h6>
                                        <label className='c8 fb '>{status2.length}</label>
                                    </div>
                                    {final(status1)}
                                </div>
                                <div className="b41  cont-circ15  w32 column center">
                                    <div className='row between w90'>
                                        <h6 className='pcb10 c13 fw600 pcb20'>🚧 Aguardando pagamento</h6>
                                        <label className='c13 fb '>{status2.length}</label>
                                    </div>
                                    {final(status2)}
                                </div>
                                <div className="b42  cont-circ15  w32 column center">
                                    <div className='row between w90'>
                                        <h6 className='pcb10 c14 fw600 pcb20'>💵 Pago Finalizado</h6>
                                        <label className='c14 fb'>{status3.length}</label>
                                    </div>
                                    {final(status3)}
                                </div>
                            </div>
                            }

                        </div>     
                    </div>
                </div>
            </div>
        
        </section>
      </>
    )
}




